var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTurboPump(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "svg3976",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 300 137.68745",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "turbo-pump",
    transform: "matrix(3.8451 0 0 3.8451 -486.14159 -1397.6618)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "rect2080",
    style: {
      fill: "#333",
      stroke: "#000",
      strokeOpacity: 1,
      paintOrder: "markers stroke fill"
    },
    d: "M143.63594 364.25983v19.9336h-13.75v-.98633h-3.31641v12.51172h3.31641v-.94532h13.75v4.29493h59.95508v-34.8086z",
    transform: "translate(.36210735 -.26764479)"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTurboPump);
export default __webpack_public_path__ + "static/media/turbo-pump.4501e0389aa73ff00ae43c4efb8e4986.svg";
export { ForwardRef as ReactComponent };